var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteEventBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 890,
    height: 206,
    viewBox: "0 0 890 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 175.676C18.8232 167.788 35.7494 160.576 54.0436 156.887C63.2151 155.037 72.3691 152.037 81.7008 151.253C94.1542 150.208 106.826 150.817 119.316 150.817C129.901 150.817 139.668 151.341 149.917 154.197C170.934 160.054 191.574 167.462 213.082 171.46C228.438 174.315 244.127 173.713 259.674 173.713C270.054 173.713 280.481 173.996 290.856 173.677C299.547 173.41 308.391 172.399 317.096 173.096C321.276 173.43 327.877 178.947 331.634 176.185C333.555 174.772 336.286 173.746 336.286 171.097",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M476.886 159.995C483.914 160.219 490.757 162.243 497.787 162.754C504.834 163.267 511.709 163.674 518.791 163.674C531.618 163.674 544.317 163.182 557.119 162.805C570.642 162.408 582.647 163.931 595.651 167.763C608.359 171.507 621.814 173.793 635.104 173.793C645.554 173.793 652.447 167.28 660.962 161.937C668.982 156.904 678.699 154.476 688.047 154.476C696.561 154.476 704.455 157.235 712.782 157.235",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M707.263 159.995C723.549 159.995 740.019 161.299 755.709 156.111C768.372 151.924 781.023 148.225 793.168 142.619C801.819 138.627 810.182 137.918 819.487 137.918C823.03 137.918 826.573 137.918 830.117 137.918C835.021 137.918 838.802 140.068 843.506 141.189C849.327 142.574 853.578 144.357 859.961 144.357C866.923 144.357 874.194 144.512 880.71 141.597C882.833 140.647 886.17 139.758 888.477 139.758",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M314.844 64.4417C332.2 92.3772 344.698 123.307 357.621 153.537C362.416 164.753 367.317 176.125 371.372 187.676",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M315.109 65.0529C358.663 45.4409 401.908 25.1768 445.214 5.00995",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M445.213 5.00891C451.376 14.4254 455.398 25.1071 459.885 35.4122C466.185 49.8793 472.484 64.3464 478.784 78.8135C484.46 91.8475 490.135 104.881 495.811 117.915C497.092 120.858 499.565 124.531 499.413 127.834",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M369.642 186.998C374.036 196.472 387.682 192.311 395.471 190.35C400.18 189.163 404.875 186.988 409.385 185.177C414.952 182.942 420.691 181.504 426.214 179.017C443.949 171.031 454.606 166.45 471.834 157.564C476.014 155.408 480.216 152.612 484.546 150.663C488.982 148.665 493.37 143.208 497.657 141.131C505.92 137.127 493.663 110.229 491.176 106.983",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M345.767 63.1405C339.67 64.8758 335.103 62.1132 332.878 56.4783C331.792 53.7272 332.896 51.4673 335.434 50.0017C338.081 48.4728 340.887 49.0611 342.18 52.0304",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M359.716 56.8578C353.619 58.593 349.052 55.8304 346.827 50.1956C345.741 47.4445 346.845 45.1846 349.383 43.719C352.03 42.1901 354.836 42.7784 356.129 45.7477",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M373.665 50.5766C367.569 52.3119 363.001 49.5493 360.777 43.9144C359.691 41.1633 360.795 38.9034 363.333 37.4378C365.98 35.9089 368.786 36.4972 370.079 39.4665",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M387.615 44.2953C381.519 46.0305 376.951 43.2679 374.726 37.6331C373.64 34.882 374.745 32.6221 377.282 31.1565C379.929 29.6276 382.735 30.2159 384.028 33.1852",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M401.564 38.0144C395.468 39.7497 390.9 36.9871 388.676 31.3522C387.589 28.6011 388.694 26.3412 391.232 24.8756C393.879 23.3467 396.685 23.935 397.978 26.9043",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M415.513 31.7332C409.417 33.4684 404.849 30.7058 402.625 25.0709C401.538 22.3198 402.643 20.0599 405.181 18.5943C407.828 17.0654 410.634 17.6538 411.927 20.623",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M429.463 25.4523C423.366 27.1876 418.799 24.425 416.574 18.7901C415.488 16.039 416.592 13.7791 419.13 12.3135C421.777 10.7846 424.583 11.3729 425.876 14.3422",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M345.313 95.5853C347.313 98.6443 352.568 108.257 351.105 104.898",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M346.041 95.2576C347.91 94.4161 349.779 93.5746 351.648 92.7331C352.956 92.144 356.243 89.907 357.876 90.4189C360.481 91.235 362.253 97.6432 363.283 99.9546C363.6 100.667 364.957 102.557 363.494 102.656C359.17 102.947 355.12 105.298 351.185 107.07",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M372.499 83.3442C374.498 86.4032 379.753 96.0159 378.291 92.6573",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M373.227 83.0167C375.096 82.1752 376.965 81.3337 378.834 80.4922C380.142 79.9031 383.429 77.6661 385.062 78.178C387.667 78.9941 389.439 85.4023 390.469 87.7137C390.786 88.4259 392.143 90.3164 390.68 90.4149C386.356 90.706 382.306 93.0573 378.371 94.8293",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M360.837 127.251C362.836 130.31 368.091 139.922 366.629 136.564",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M361.565 126.923C363.434 126.081 365.303 125.24 367.172 124.398C368.48 123.809 371.767 121.572 373.401 122.084C376.005 122.9 377.777 129.309 378.807 131.62C379.124 132.332 380.481 134.223 379.018 134.321C374.695 134.612 370.644 136.964 366.709 138.736",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M369.927 148.126C371.927 151.185 377.182 160.797 375.719 157.439",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M370.656 147.799C372.525 146.958 374.393 146.116 376.262 145.275C377.57 144.686 380.857 142.449 382.491 142.961C385.095 143.777 386.868 150.185 387.897 152.496C388.215 153.208 389.571 155.099 388.109 155.197C383.785 155.489 379.735 157.84 375.799 159.612",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M378.546 166.921C380.545 169.98 385.8 179.593 384.338 176.234",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M379.274 166.595C381.143 165.753 383.012 164.912 384.881 164.07C386.189 163.481 389.476 161.244 391.109 161.756C393.714 162.572 395.486 168.981 396.516 171.292C396.833 172.004 398.19 173.895 396.727 173.993C392.403 174.284 388.353 176.635 384.418 178.407",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M399.688 71.1014C401.687 74.1604 406.942 83.773 405.48 80.4144",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M400.416 70.7737C402.285 69.9322 404.154 69.0907 406.023 68.2492C407.331 67.6601 410.618 65.4231 412.251 65.935C414.856 66.7511 416.628 73.1594 417.658 75.4707C417.975 76.1829 419.332 78.0734 417.869 78.1719C413.545 78.4631 409.495 80.8143 405.56 82.5863",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M426.876 58.8552C428.875 61.9142 434.13 71.5268 432.668 68.1683",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M427.606 58.5297C429.475 57.6882 431.344 56.8467 433.213 56.0052C434.521 55.4161 437.808 53.1791 439.441 53.691C442.046 54.5071 443.818 60.9153 444.848 63.2267C445.165 63.9389 446.522 65.8294 445.059 65.9279C440.735 66.219 436.685 68.5703 432.75 70.3423",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M351.706 98.8907C352.061 97.622 352.413 96.4561 353.11 95.3409C353.719 94.366 353.265 95.7706 353.247 96.3411C353.21 97.5084 353.063 99.1599 353.546 100.268C353.753 100.745 354.95 99.0095 355.049 98.8445C355.177 98.6301 355.721 96.9319 355.87 97.8563C356.136 99.5196 355.766 100.963 355.661 102.595C355.58 103.851 357.185 101.089 357.291 100.858C357.702 99.9653 358.151 99.1064 358.669 98.2763",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M329.168 96.5032C347.506 79.6004 371.097 71.1992 393.401 61.1558C410.693 53.3694 428.263 46.1713 445.529 38.3965C450.253 36.2696 454.948 35.583 459.644 33.4684",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M388.082 121.894C413.934 108.279 441.584 98.2914 467.692 85.215",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M421.618 112.607C438.371 105.064 454.933 97.1907 471.668 89.6546",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M411.387 135.076C431.112 126.194 450.837 117.312 470.562 108.43C473.073 107.299 475.211 106.325 477.941 105.938",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M313.423 65.31C316.38 72.6519 317.447 80.8263 319.397 88.4762C322.072 98.9714 324.394 109.611 327.351 120.023C330.913 132.572 333.569 145.208 334.188 158.286C334.34 161.487 334.813 164.546 335.736 167.563C336.185 169.03 336.045 170.521 336.24 172.028C336.527 174.252 337.222 176.289 338.111 178.323C339.164 180.732 339.879 182.991 340.486 185.533C340.834 186.989 341.004 189.002 341.764 190.29C342.589 191.689 343.079 192.924 343.617 194.444C344.309 196.397 345.891 198.049 346.838 199.879C347.458 201.076 349.015 202.153 350.275 202.514C351.517 202.87 352.642 203.366 353.838 203.832C355.158 204.346 357.036 203.103 358.193 202.66C360.469 201.789 362.774 200.846 365.139 200.245C366.281 199.955 367.432 199.943 368.558 199.55C370.394 198.908 372.257 196.78 374.154 196.374C375.344 196.119 395.255 190.29 395.255 190.29",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M314.395 66.2964C314.892 78.1759 320.172 89.584 323.752 100.735C325.681 106.741 326.989 113.078 329.726 118.777C330.686 120.775 330.889 123.267 331.562 125.401C332.59 128.663 333.1 132.023 334.477 135.173C337.315 141.667 337.7 149.1 339.335 155.924C340.424 160.467 342.49 164.591 343.798 169.062C344.806 172.507 345.627 175.978 347.451 179.108C349.624 182.837 352.05 186.408 353.695 190.435C355.098 193.871 356.991 196.569 359.525 199.145C360.063 199.692 360.694 200.004 361.217 200.536",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M316.339 66.9565C316.715 71.1653 317.425 75.2039 318.966 79.1435C321.573 85.81 323.675 92.6346 326.164 99.3453C328.621 105.971 331.781 112.271 333.865 119.035C334.866 122.284 336.437 125.213 337.554 128.404C338.571 131.31 339.915 134.059 341.297 136.803C343.205 140.591 344.653 144.499 346.299 148.404C347.795 151.953 349.49 155.404 351.158 158.871C353.136 162.983 354.664 167.235 356.826 171.259C358.337 174.071 359.959 176.916 361.289 179.823C362.15 181.707 362.558 183.747 363.376 185.642C364.452 188.136 366.637 190.656 367.209 193.273C367.396 194.128 368.552 195.743 369.134 196.42",
    stroke: "#FB7C51",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M514.2 125.574C514.54 125.824 514.852 126.147 515.179 126.427C515.818 126.975 516.474 127.484 517.121 128.013C517.91 128.657 518.66 129.392 519.457 130.016C519.684 130.193 519.932 130.342 520.149 130.546C520.235 130.627 520.192 130.519 520.167 130.424",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M529 111.758C527.832 113.47 527.015 115.402 526.144 117.274C525.096 119.528 524.046 121.782 522.996 124.035C521.863 126.464 520.937 128.961 519.884 131.418",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M504.242 100.415C501.894 103.995 498.837 108.013 498.059 112.347C497.671 114.506 497.755 116.669 497.755 118.853C497.755 120.999 497.629 123.191 497.926 125.321C498.33 128.22 499.523 131.129 500.648 133.829C501.578 136.06 502.965 138.215 505.058 139.51C507.367 140.94 509.878 141.413 512.399 142.393C514.306 143.135 517.086 142.754 519.086 142.754C521.548 142.754 524.011 142.754 526.474 142.754C529.107 142.754 531.639 142.112 534.156 141.35C536.462 140.652 538.89 139.779 540.881 138.382C543.449 136.578 545.788 134.052 546.789 131.012C547.804 127.932 547.434 124.494 547.434 121.3C547.434 119.998 547.456 118.694 547.434 117.393C547.408 115.831 546.789 114.283 546.344 112.812C545.483 109.966 543.928 107.627 541.478 105.86C539.739 104.604 537.454 103.836 535.484 103.033C533.477 102.215 531.402 101.485 529.31 100.985C527.836 100.632 526.419 100.067 524.966 99.6567C524.337 99.4793 523.623 99.5321 523.022 99.2773C522.452 99.036 522.098 98.9011 521.466 98.8695C520.148 98.8036 518.917 98.3668 517.587 98.3668C516.183 98.3668 514.779 98.1961 513.366 98.1961C510.31 98.1961 507.248 97.7513 504.925 100.074",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteEventBg);
export default __webpack_public_path__ + "static/media/DeleteEventBg.7748556ac76e18e2edb2a6c33b37f3fa.svg";
export { ForwardRef as ReactComponent };